import React, { useState } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { Chip, LinearProgress } from "@material-ui/core";
import cardholderDataColumn from "../../dataColumns/cardholderDataColumn";
import useCardholders from "../../hooks/modules/cardholder/useCardholders";
import useStyles from "../../hooks/useStyles";
import { Strings } from "../../assets/res/en";
import { SearchBar } from "../../components/searchBox/SearchBar";
import Unauthorized from "../../components/Unauthorized";
import BalanceModal from "../../modals/BalanceModal/BalanceModal";
import miniCMSDataColumn from "../../dataColumns/miniCMSDataColumn";
import useMiniCMSCardholders from "../../hooks/modules/cardholder/useMiniCMSCardholders";

export default function MiniCMS() {
  const classes = useStyles();
  const { columns, sytlingOptions } = miniCMSDataColumn(classes);
  const {
    filters,
    searchData,
    getAllCardholders,
    searchOptions,
    tableRef,
    cardHolderPermission,
  } = useMiniCMSCardholders();

  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState()

  const onRowClick = (e, rowData) => {
    console.log(rowData)
    setSelected(rowData)
    setOpen(true)
  }

  const onCloseBalanceModal = () => {
    setSelected(null)
    setOpen(false)
  }


  let dataOptions = {...searchOptions}
  //console.log(dataOptions)

  console.log(filters)
  let _filter = []
  filters.forEach(item => {
    if(item.name !== 'sGroup' && item.name !== 'sLocation') _filter.push(item)
  })

  return (
    <>
      {cardHolderPermission.read === true ? (
        <>
          <BalanceModal open={open} onClose={onCloseBalanceModal} cardholder={selected}/>
          <SearchBar options={searchOptions} />
          <MaterialTable
            onRowClick={onRowClick}
            title={'Search Cardholder Mini CMS'}
            columns={columns}
            tableRef={tableRef}
            data={(query) => getAllCardholders(query)}
            options={sytlingOptions}
            components={{
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div
                    className={
                      _filter.filter(
                        (item) =>
                          item.value && item.value.toString().trim() !== ""
                      ).length > 0
                        ? classes.filterContainer
                        : ""
                    }
                  >
                    {_filter.filter(
                      (item) =>
                        item.value && item.value.toString().trim() !== ""
                    ).length > 0 &&
                    _filter
                        .filter(
                          (item) =>
                            (item.value &&
                              item.value.toString().trim() !== "") ||
                            item.isClearAll === true
                        )
                        .map((fItem) =>
                          fItem.isClearAll === true ? (
                            <Chip
                              key={fItem.name}
                              color="secondary"
                              label="Reset All Filters"
                              onClick={() => fItem.clearAll(_filter)}
                            />
                          ) : (
                            <Chip
                              key={fItem.name}
                              color="default"
                              label={fItem.value}
                              onDelete={() =>
                                fItem.remove(fItem, _filter, searchData)
                              }
                            />
                          )
                        )}
                  </div>
                </div>
              ),
            }}
          />
        </>
      ) : cardHolderPermission.read === false ? (
        <Unauthorized />
      ) : (
        <LinearProgress />
      )}
    </>
  );
}
